import React, { useState } from 'react';
import CloseIcon from '../../../assets/svg/closeIcon';
import axiosVendorInstance from '../../../axiosVendorInstance';

const CouponCodeInput = ({
    coupons,
    setSelectedCoupon,
    setSelectedCouponAmount,
    userId,
    vendorId,
    selectedCoupon,
    setSelectedOffer,
    setSelectedOfferPercentage,
    selectedOffer,
    price
}) => {
    const [inputCoupon, setInputCoupon] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isCouponApplied, setIsCouponApplied] = useState(false);

    const handleCouponCode = (e) => {
        setInputCoupon(e.target.value);
        if (errorMessage) {
            setErrorMessage('');
        }
    };

    const validateCoupon = async (couponID) => {
        try {
            const response = await axiosVendorInstance.post(`/vendor/vendors/${vendorId}/check-coupon-redemption`, {
                coupon_id: couponID,
                user_id: userId,
                totalAmount: price
            });
            return response?.data;
        } catch (error) {
            console.error('Error validating coupon:', error);
            const errorMessage = error?.response?.data?.error || 'Failed to validate coupon.';
            return { used: false, error: errorMessage };
        }
    };

    const handleApplyInputCoupon = async () => {
        const couponRegex = /^(?!-)(?!.*--)[A-Z0-9-]{5,20}(?<!-)$/;

        if (!inputCoupon.trim()) {
            setErrorMessage('Please enter a coupon code.');
            return;
        }

        if (!couponRegex.test(inputCoupon)) {
            setErrorMessage('Invalid format! Use 5-20 letters, numbers, or hyphens.');
            return;
        }

        const coupon = coupons?.find(c => c.Coupon_code?.toUpperCase() === inputCoupon.toUpperCase());

        if (coupon) {
            const redemptionStatus = await validateCoupon(coupon?.ID);
            if (redemptionStatus.error) {
                setErrorMessage(redemptionStatus.error);
            } else {
                setSelectedCoupon(coupon?.Coupon_code);
                setSelectedCouponAmount(coupon?.max_amount);
                setSelectedOffer(null); 
                setSelectedOfferPercentage?.(null);
                setErrorMessage('');
                setIsCouponApplied(true);
            }
        } else {
            setErrorMessage('Enter a valid coupon code.');
        }
    };

    const clearCouponCode = () => {
        setInputCoupon('');
        setSelectedCoupon(null);
        setSelectedCouponAmount(null);
        setIsCouponApplied(false);
    };

    return (
        <>
            <div className="coupon-input-and-btn">
                {selectedCoupon ? (
                    <>
                        <div className="coupon-input">{selectedOffer ? '' : selectedCoupon}</div>
                        <CloseIcon
                            className="clear-coupon-code-close-icon"
                            onClick={clearCouponCode}
                            style={{ cursor: 'pointer', marginLeft: '10px' }} />
                    </>
                ) : (
                    <>
                        <input
                            type="text"
                            placeholder="Enter Your Coupon Code"
                            className="coupon-input"
                            value={inputCoupon}
                            onChange={handleCouponCode}
                            maxLength={20} />
                        {isCouponApplied ? (
                            <CloseIcon
                                className="clear-coupon-code-close-icon"
                                onClick={clearCouponCode} />
                        ) : (
                            <button onClick={handleApplyInputCoupon} className="apply-coupon-btn">
                            Apply
                            </button>
                        )}
                    </>)}
            </div>
            <div style={{ minHeight: '15px' }}>
                {errorMessage && <div className="error-message-coupons-and-offers">{errorMessage}</div>}
            </div>
        </>
    );
};

export default CouponCodeInput;
